import { render, staticRenderFns } from "./InfoStructure.vue?vue&type=template&id=7244701c&scoped=true"
import script from "./InfoStructure.vue?vue&type=script&lang=js"
export * from "./InfoStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244701c",
  null
  
)

export default component.exports